'use client'

import { useTimer } from '../../lib/timer'

const formatTime = ({
  hours,
  minutes,
  seconds,
}: {
  hours: number
  minutes: number
  seconds: number
}) => {
  return `${hours}시간 ${minutes}분 ${seconds}초`
}

type Props = {
  deadline: string
  onEnd?: () => void
}

export const DeadlineTimer = ({ deadline, onEnd }: Props) => {
  const { timeLeft } = useTimer({
    time: deadline,
    onEnd,
    format: formatTime,
  })

  return <span className="font-semibold text-purple-500">{timeLeft}</span>
}
